import { isTourSchedulingEnabled } from './resultsFeatureFlags';

function hasStrictCapability(accessState, name) {
  return accessState?.capabilities?.[name] === true;
}

export function isUsageAdminUser(accessState) {
  return hasStrictCapability(accessState, 'usageAdmin');
}

export function isResultsFeatureAdminUser(accessState) {
  return hasStrictCapability(accessState, 'resultsFeature');
}

export function isTourSchedulingFeatureUser(accessState) {
  return hasStrictCapability(accessState, 'tourScheduling');
}

export function canUseTourScheduling(accessState) {
  return isTourSchedulingFeatureUser(accessState) && isTourSchedulingEnabled();
}
